import React from 'react';
import './Proposal.css'
import firebase from '../../services/Firebase'
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    withRouter,
    useParams
} from 'react-router-dom';



function useProposal() {

    const [proposal, setProposal] = React.useState([]);
    const { id } = useParams();
  
    React.useEffect(() => {
        firebase.firestore().collection('proposals').doc(id).onSnapshot(snapshot => {
            setProposal(snapshot.data())
  
        })
    }, []);
  
    return proposal;
  
  }

  

function useComments() {

    const [comments, setComments] = React.useState([]);
    const { id } = useParams();

    React.useEffect(() => {
        firebase.firestore().collection('comments')
            .where("project", "==", id)

            .onSnapshot((snapshot) => {
                const newComments = snapshot.docs.map((doc) => ({
                    id: doc.id,
                    ...doc.data()
                }))
                setComments(newComments)
            })
    }, []);

    return comments;
}


function Proposal(props) {

    const proposal = useProposal();


    const comments = useComments();
    const { id } = useParams();

    const [comment, setComment] = React.useState("");


    const handleCommentChange = event => {
        setComment(event.target.value);
    }

    const addComment = event => {
        firebase.firestore().collection('comments').add({
            sender: { name: "Tin", img: "https://www.xing.com/image/8_8_5_4e8c52173_23470511_1/tin-stribor-sohn-foto.1024x1024.jpg" },
            message: comment,
            timestamp: Date.now(),
            project: id
        })
    }


    return (<>

<div className="project-main-container">

        <div className="project-main-proposals-container">

            <h1>{proposal.name}</h1>
    <h3>{proposal.caption}</h3>

    <p>{proposal.description}</p>
    <h1>Team</h1>

        {proposal.members && proposal.members.map(member => 
            
            <div className="member-container">
                <img className="member-img" src={member.imgurl}></img>
                <span>
                    <span><b> {member.name} </b></span>
                    <span>{member.role}</span>
                </span>
            </div>
            
            )}


            <button className="projects-enter-button">Mitmachen!</button>
        <h1>Assets</h1>
            {proposal.assets && proposal.assets.map(asset => 
                <div>
                    <p><a target="_blank" href={asset.url}>{asset.type}</a></p>
                    </div>
                )}
        </div>
        <div className="project-main-proposals-container">
            <h1>
                Kommentare
                    </h1>


            <div><input type="text" value={comment} placeholder="ein Kommentar schreiben..." onChange={handleCommentChange} className="comment-input"></input><button onClick={addComment} className="projects-button" >Kommentieren</button></div>


            {comments.map(comment => <div className="comment-item">
                <img className="comment-profile-picture" src={comment.sender.img}></img> <p>{comment.sender.name}</p>
                <p>{comment.message}
                </p>


            </div>)}





        </div>
        </div>
    </>)
}


export default withRouter(Proposal)